// Shared empty state — rendered for any tab whose feature isn't registered yet
// (plan §2.5). At F-SHELL merge zero features are registered, so all 5 tabs
// show this. Each wave-1 feature's `register.ts` swaps its tab's ComingSoon for
// its real Pane automatically (the registry then has a Pane for that id).
//
// The reference implementation of CLAUDE.md §9: pure Tailwind, logical
// utilities only, all strings via t('shell.comingSoon.*'). `dir` (set by
// i18n) drives RTL — no per-component dir.

import { useTranslation } from 'react-i18next'
import type { TabId } from './tab-registry'

interface ComingSoonProps {
  tab: TabId
}

export function ComingSoon({ tab }: ComingSoonProps): JSX.Element {
  const { t } = useTranslation()
  return (
    <div
      data-testid="shell-coming-soon"
      data-tab={tab}
      className="flex flex-1 flex-col items-center justify-center gap-2 px-6 py-12 text-center"
    >
      <div className="font-serif text-base font-semibold text-ink">
        {t('shell.comingSoon.title')}
      </div>
      <p className="max-w-[260px] text-xs leading-relaxed text-ink/60">
        {t('shell.comingSoon.body')}
      </p>
    </div>
  )
}
